
import { get, post } from '../utils/http'

export const changeTab = (searchType) => (get('FETCH_LAWREPORT_CATEGORIES', `/lawreports/categories?searchType=${searchType}&skipCache=true&includeHidden=true`, 'payload', { searchType, index: 0, options:[] }))

export const selectCategory = (searchType, options) => {

  let optionsQuery = options.map((o) => `options=${o}`).join('&');

  return get('FETCH_LAWREPORT_CATEGORIES', `/lawreports/categories?searchType=${searchType}&${optionsQuery}&includeHidden=true`, 'payload', { searchType, index: options.length, options })
}

export const edit = (searchType, source, options) => {

  options = Array.isArray(options)? options : [options];

  let optionsQuery = options.map((o) => `option=${encodeURIComponent(o)}`).join('&')
  let sourceQuery = source ? `&source=${encodeURIComponent(source)}` : '';

  return get('FETCH_LAWREPORT_EDIT', `/lawreports?searchType=${searchType}&${optionsQuery}${sourceQuery}`)
}

export const selectSbt = (id) => ({type: 'LAWREPORT_SELECT_SBT', payload:id })

export const nextSbt = () => ({type: 'LAWREPORT_NEXT_SBT' })

export const prevSbt = () => ({type: 'LAWREPORT_PREV_SBT' })

export const firstSbt = () => ({type: 'LAWREPORT_FIRST_SBT' })

export const lastSbt = () => ({type: 'LAWREPORT_LAST_SBT' })

export const showNewLawReportDialog = () => ({type: 'LAWREPORT_SHOW_NEW' })

export const hideNewLawReportDialog = () => ({type: 'LAWREPORT_HIDE_NEW' })

export const loadTemplates = () => (get('LAWREPORT_FETCH_TEMPLATES', '/admin/lawreports/templates/list'))

export const createLawReport = (originalFileName, templateId) => {
  let form = new FormData();
  form.append('originalFileName', originalFileName);
  form.append('templateId', templateId);
  return post('LAWREPORT_CREATE', '/admin/lawreports', form);
}

export const changeOriginalFilename = (originalFileName) => ({type: 'LAWREPORT_CHANGE_ORIGINAL_FILENAME', payload:originalFileName })

export const changeTemplateId = (templateId) => ({type: 'LAWREPORT_CHANGE_TEMPLATE_ID', payload:templateId })


// WEBPACK FOOTER //
// ./src/lawreport/lawReportActions.js